import React from "react";
import { Box, Card, Typography } from "@mui/material";
import workshopImage from "../../../images/noSelectionBackdrop.png";
import WestIcon from "@mui/icons-material/West";

const NoWorkshopSelected = () => {
  return (
    <Box
      sx={{
        bgcolor: "background.main",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        backgroundImage: `url(${workshopImage})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <WestIcon fontSize="large" />
      <Typography variant="h1" textAlign="center" sx={{ fontWeight: "550" }}>
        Select A Workshop
      </Typography>
    </Box>
  );
};

export default NoWorkshopSelected;
